import React from 'react';

import clsx from 'clsx';

import * as classes from './Block.module.css';

const Block = ({
    id,
    type,
    ...props
}) => {

    const renderBlock = () => {
        switch (type) {
            case 'Round':
                return 'Round';
            case 'Min':
                return 'Min';
            case 'Max':
                return 'Max';
            case 'Average':
                return 'Average';
            case 'Is Even':
                return 'Is Even';
            case 'Is Odd':
                return 'Is Odd';
            case 'Is Prime':
                return 'Is Prime';
            case 'Is Whole':
                return 'Is Whole';
            case 'Is Positive':
                return 'Is Positive';
            case 'Is Negative':
                return 'Is Negative';
            case 'Square Root':
                return 'Square Root';
            case 'Round Up':
                return 'Round Up';
            case 'Round Down':
                return 'Round Down';
            case 'Absolute':
                return 'Absolute';
            case 'Log 10':
                return 'Log 10';
            case 'e^x':
                return 'e^';
            case '10^x':
                return '10^';
            case 'Median':
                return 'Median';
            case 'Modes':
                return 'Modes';
            case 'Standard Deviation':
                return 'Standard Deviation';
            case 'Random Item':
                return 'Random Item';
            default:
                return 'Type';
        }
    };

    return (
        <span style={{ display: 'flex', alignItems: 'center' }} id={`${id}-math-block`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div
                data-allow-insert={false}
                data-type={type}
                id={`${id}-math-block`}
                className={classes.Block}
            >
                <div
                    data-allow-insert={false}
                    data-type={type}
                    id="math-start"
                    className={classes.BlockBody}
                >
                    <span data-allow-insert={false}>{renderBlock(type)}</span>
                    <span style={{display: 'flex', alignItems: 'center'}}>(  )</span>
                </div>
                <div data-type={type} id="math-end" />
                <span
                    data-allow-insert={false}
                    id={`${id}-delete`}
                    role="none"
                    class={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    delete
                </span>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default Block;
